import CustomInput from '../CustomInput';

const FORTING_NUMBERS = /(^$)|(^[1-9][0-9]{0,10}$)/;

class ResidenceCertificateNumberInput extends CustomInput {
  transform = value => this.clearSpaces(value);

  validate = value => FORTING_NUMBERS.test(value);
}

export default ResidenceCertificateNumberInput;

// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// export default function ResidenceCertificateNumberInput(props) {
//   const mask = "1".repeat(14);
//
//   return <MaskedInput mask={mask} placeholder="" {...props} />;
// }
